import Chip from '@zenbusiness/zui/Chip';
import { superstyled } from '@zenbusiness/zui/styles';

export const Pill = superstyled({
  name: 'ZuiHeroPill',
  slot: 'Root',
  tag: Chip,
  styles: () => ({
    display: 'flex',
    padding: 0,
    width: 'fit-content'
  })
});
